/**
 * The names of the export files
 */
export const exportNames = {
  evaluationListWound: "evaluationListWound",
  evaluationListBraden: "evaluationListBraden",
  evaluationListTotalSkin: "evaluationListTotalSkin",
  evaluationListPURS: "evaluationListPurs"
};
